import axios from '../utils/axios';

export default function executeMailer(adminId, id) {
    return (
        axios.post(`/admin/${adminId}/tag-mailers/${id}/execute-test`, {})
    )
}
